'use client'

import { DSA_APPEAL_EDUCATION_URL } from 'constants/routes'
import { useConversationContext } from '@marketplace-web/domain/core-conversation'
import {
  ConversationActionButton,
  ConversationActionProps,
} from '@marketplace-web/domain/conversation-action'

type Props = ConversationActionProps

const AppealTheDecision = ({ primary, title, inverse, theme, size }: Props) => {
  const { conversation } = useConversationContext()

  if (!conversation?.id) return null

  return (
    <ConversationActionButton
      primary={primary}
      text={title}
      size={size}
      inverse={inverse}
      theme={theme}
      url={DSA_APPEAL_EDUCATION_URL(Number(conversation.id))}
      testId="appeal-the-decision-conversation-action"
    />
  )
}

export default AppealTheDecision
